import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';

import { Box } from '@mui/system';
import Details from '../../components/details';
import ProfileContext from '../../context/ProfileContext';
import StaffContext from '../../context/StaffContext';
import TeachingLoad from '../../components/tables/100/TeachingLoad';
import ActiveResearch from '../../components/tables/100/ActiveResearch'
import { Tab, Tabs, Tooltip } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Route, Routes, useNavigate,Navigate } from 'react-router-dom';
import ExtensionLoad from '../../components/tables/100/ExtensionLoad';
import RequireAuth from '../../components/RequireAuth';
import useAuth from '../../hooks/useAuth';
export default function Home() {
  const navigate=useNavigate();
  const DetailWrapper=styled(Box)(({theme})=>({
    display:"flex",
    flexWrap:'wrap',
    gap:"33px",
    margin:"20px",
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    paddingBottom:'44px',
    borderRadius:'2px',
  }))
  const InfoWrapper=styled(Box)({
    width:'100%',
    marginLeft:'10px',
    display:'flex',
    flexDirection:'column',
    gap:'10px',

  })
  const {state:office}=useContext(StaffContext)
  const {state}=useContext(ProfileContext);
  const details=state.details
  const [table,setTable]=useState(window.location.pathname)
  const HandleChange = (event, newValue) => {
    setTable(newValue);
    navigate(newValue);
  };
  const {user}=useAuth();
  const hasOffice=user?.roles?Math.max(...user?.roles)===115:false
  const roles=user?.roles;
  return (
    <>
    {
      (office.office && !hasOffice) && <Navigate to='/dashboard'/>
    }
    <DetailWrapper>
      <Tooltip title="See Details">
      <Details 
         value={details.load} 
         text="Total WorkLoad" 
         icon='work'
         option1="Teaching Load"
         option2="Research Load"
         option3="Position Load"
         value1={details.academic_load}
         value2={details.research_load}
         value3={details.position_load}
      />
      </Tooltip>
      <Details value={details.n_groups} text="Teaching Group Loads" icon='teach'/>
      <Details value={details.a_research} text="Active Researches" icon='research'/>
    </DetailWrapper>
    <InfoWrapper>
      <Tabs
          value={table}
          onChange={HandleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="secondary tabs example"
          sx={{
              fontFamily: 'Poppins',
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "18px",
          }}
        >
         {roles?.includes(101) && <Tab value="/" label="Teaching Load" />}
         {roles?.includes(102) &&  <Tab value="/a_research" label="Research Load" />}
         {roles?.includes(103) &&  <Tab value="/e_load" label="Extension Load" />}
        </Tabs>
       <Routes>
        <Route element={<RequireAuth allowedRoles={[101]}/>}>
        <Route exact path="/" element={ <TeachingLoad />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[102]}/>}>
        <Route exact path="/a_research" element={<ActiveResearch/> } />
        </Route>
        <Route element={<RequireAuth allowedRoles={[103]}/>}>
        <Route exact path="/e_load" element={<ExtensionLoad/> } />
        </Route>
      </Routes>  
    </InfoWrapper>
  
    
    </>
  )
}
